import {
  ANALYTICS_CATEGORY_PATH,
  analyticsCategory,
  DOCUMENTATION_CATEGORY_PATH,
  documentationCategory,
  LINKS_CATEGORY_PATH,
  linksAndCreativesCategory,
  OVERVIEW_CATEGORY_PATH,
  overviewCategory,
  PAYOUTS_CATEGORY_PATH,
  payoutsCategory,
  REFERRAL_PROGRAM_CATEGORY_PATH,
  referralProgramCategory,
  SERVICE_CATEGORY_PATH,
  serviceCategory,
  whiteLabelsCategory,
} from './common';

export const ANALYTICS_MEMBER_INSPECTOR_PATH = `${ANALYTICS_CATEGORY_PATH}/member-inspector`;

export const DOCUMENTATION_TRACK_URL_PATH = `${DOCUMENTATION_CATEGORY_PATH}/track-url`;
export const DOCUMENTATION_LANDING_OPTIONS_PATH = `${DOCUMENTATION_CATEGORY_PATH}/landing-options`;
export const DOCUMENTATION_SCRIPTS_PATH = `${DOCUMENTATION_CATEGORY_PATH}/scripts`;
export const DOCUMENTATION_MODELS_LIST_PATH = `${DOCUMENTATION_CATEGORY_PATH}/models-list`;

export const OVERVIEW_DASHBOARD_PATH = `${OVERVIEW_CATEGORY_PATH}/dashboard`;
export const OVERVIEW_ACCOUNT_PATH = `${OVERVIEW_CATEGORY_PATH}/account`;
export const OVERVIEW_CPL_PATH = `${OVERVIEW_CATEGORY_PATH}/cpl`;
export const affiliatesOverviewCategory = overviewCategory;

export const LINKS_LINKS_BUILDER_PATH = `${LINKS_CATEGORY_PATH}/links-builder`;
/** @deprecated */ export const LINKS_CREATIVES_BUILDER_PATH = `${LINKS_CATEGORY_PATH}/creatives-builder`;
export const LINKS_AD_CREATIVES_BUILDER_PATH = `${LINKS_CATEGORY_PATH}/ad-creatives-builder`;
export const LINKS_BANNERS_PATH = `${LINKS_CATEGORY_PATH}/banners`;
export const LINKS_WIDGETS_PATH = `${LINKS_CATEGORY_PATH}/widgets`;
export const LINKS_POPUNDERS_PATH = `${LINKS_CATEGORY_PATH}/popunders`;
export const LINKS_PRE_ROLLS_PATH = `${LINKS_CATEGORY_PATH}/pre-rolls`;
/** @deprecated */ export const LINKS_SMART_LINKS_PATH = `${LINKS_CATEGORY_PATH}/smart-links`;
export const LINKS_SMART_LINK_PATH = `${LINKS_CATEGORY_PATH}/smart-link`;
export const EASY_LINKS_PATH = `${LINKS_CATEGORY_PATH}/easy-links`;
export const MODELS_TRAFFIC_PATH = `${LINKS_CATEGORY_PATH}/models-traffic`;
export const affiliatesLinksAndCreativesCategory = linksAndCreativesCategory;

/** @deprecated */ export const PAYOUTS_HISTORY_PATH = `${PAYOUTS_CATEGORY_PATH}/history`;
export const PAYOUTS_PAYOUT_HISTORY_PATH = `${PAYOUTS_CATEGORY_PATH}/payout-history`;
/** @deprecated */ export const PAYOUTS_SETUP_PATH = `${PAYOUTS_CATEGORY_PATH}/setup`;
export const PAYOUTS_PAYOUTS_SETUP_PATH = `${PAYOUTS_CATEGORY_PATH}/payout-setup`;
export const EARNINGS_LOG_PATH = `${PAYOUTS_CATEGORY_PATH}/earnings-log`;
export const affiliatesPayoutsCategory = payoutsCategory;
export const REFERRAL_PROGRAM_REFERRALS_PATH = `${REFERRAL_PROGRAM_CATEGORY_PATH}/referrals`;
export const affiliatesReferralProgramCategory = referralProgramCategory;
export const SERVICE_POSTBACK_SETUP_PATH = `${SERVICE_CATEGORY_PATH}/postback-setup`;
export const SERVICE_SECRETS_PATH = `${SERVICE_CATEGORY_PATH}/secrets`;

export const affiliatesServiceCategory = serviceCategory;

export default [
  analyticsCategory,
  affiliatesOverviewCategory,
  affiliatesLinksAndCreativesCategory,
  whiteLabelsCategory,
  affiliatesPayoutsCategory,
  affiliatesReferralProgramCategory,
  affiliatesServiceCategory,
  documentationCategory,
];
